export default __webpack_public_path__ + "static/media/icon--statistics.f49253c8.svg";